















































































































































































import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import _ from "@/boot/lodash";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import HasValidation from "@/mixins/HasValidation";
import Context from "@/mixins/context";
import CurrenciesStore from "@/mixins/constants/currenciesStore";

// Enums/Data
import { QUERY_PARAMS } from "@/data/constants";
import { IOrgRegistrationForm } from "@/models/organisation";
import { IUser } from "@/models/users";
import { IState } from "@/store";
import { ICurrency } from "@/models/constants";

@Component({
  computed: {
    ...mapState({
      baseCurrencies(state: IState, getters) {
        return getters[`constants/currencies`]({ baseOnly: true });
      }
    })
  },
  components: {
    "terms-and-conditions-statement": () =>
      import("@/components/app/global/auth/termsAndConditionsStatement.vue")
  }
})
export default class OrgRegistrationForm extends Mixins(
  RequestPromises,
  HasValidation,
  Context,
  CurrenciesStore
) {
  // Refs

  public declare $refs: {
    recaptcha: any;
    observer: InstanceType<typeof ValidationObserver>;
  };

  // Map state
  public baseCurrencies!: ICurrency[];

  // Props

  @Prop({ default: null })
  public username!: IUser["email"] | null;

  @Prop({ default: null })
  public regHash!: string | null;

  // Variables

  public registrationForm: IOrgRegistrationForm = {
    orgname: "",
    name: "",
    ...(this.isFullRegistration
      ? { email: "", password: "" }
      : {
          username: this.username,
          reg_hash: this.regHash,
          new_password: "",
          import_demo_data: false,
          currency_code: "GBP"
        }),
    recaptcha_token: ""
  };

  public isProcessing = false;
  public isSuccess = false;
  public isRedirecting = false;

  public isLoggedOut = true;

  // Methods

  public async validateBeforeSubmit() {
    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");

      this.isProcessing = true;
      if (this.isFullRegistration) {
        await this.createAccount();
        this.isSuccess = true;
      } else {
        await this.completeOrgRegistration();
        this.isRedirecting = true;
      }

      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.registration_successful")
      });
    } catch (error) {
      // Regenerate reCaptcha token for subsequent attempt
      await this.$refs.recaptcha.generateToken();

      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public completeOrgRegistration() {
    return this.$store.dispatch("auth/admin/completeOrgRegistration", {
      data: this.formData
    });
  }

  public createAccount() {
    return this.$store.dispatch("auth/admin/register", this.formData);
  }

  // Computed

  public get disableSubmitButton() {
    if (!this.hasErrors) return false;

    if (this.hasError("recaptcha_token")) {
      let hasErrors = false;
      this.$_.forEach(this.validationErrors, (error, key) => {
        if (key === "recaptcha_token") {
          return;
        }
        hasErrors = error.length !== 0;
        if (hasErrors) {
          return false;
        }
      });
      return hasErrors;
    }

    return true;
  }

  public get orderTemplateCode() {
    return this.$_.get(
      this.$route,
      `query.${QUERY_PARAMS.ORDER_TEMPLATE_CODE}`,
      ""
    );
  }

  public get isFullRegistration() {
    return _.isNull(this.username);
  }

  public get formData() {
    return {
      ...this.registrationForm,
      ...(this.orderTemplateCode
        ? { order_template_code: this.orderTemplateCode }
        : {})
    };
  }

  // Watchers

  @Watch("registrationForm", { immediate: true, deep: true })
  public onRegistrationFormChange(newForm) {
    setTimeout(() => {
      this.$emit(
        "changeCompleteValue",
        _.sum([
          (!_.isEmpty(newForm.email) && !this.hasError("email")) ||
          !this.isFullRegistration
            ? 20
            : 0,
          !_.isEmpty(newForm.orgname) && !this.hasError("orgname") ? 20 : 0,
          !_.isEmpty(newForm.name) && !this.hasError("name") ? 20 : 0,
          !_.isEmpty(newForm.password) && !this.hasError("password") ? 20 : 0,
          !_.isEmpty(newForm.new_password) && !this.hasError("new_password")
            ? 20
            : 0,
          !_.isEmpty(newForm.recaptcha_token) &&
          !this.hasError("recaptcha_token")
            ? 20
            : 0
        ])
      );
    }, 200);
  }
}
